"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _KeyInsightCard = require("./KeyInsightCard");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _utils = require("./utils");

var _DashboardDateRangeFilter = _interopRequireDefault(require("./DashboardDateRangeFilter"));

var _QueryParameters = _interopRequireDefault(require("./QueryParameters"));

var _SetupIdeaStatusMappingWarning = require("./ProductFeedbackDashboard/SetupIdeaStatusMappingWarning");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _IdeaStatusMappingModal = require("./ProductFeedbackDashboard/IdeaStatusMappingModal");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _IdeationTrendsTable = _interopRequireDefault(require("./ProductFeedbackDashboard/IdeationTrendsTable"));

var _GraphTitle = require("./GraphTitle");

var _Loader = require("./Loader");

var _LazyCharts = require("./LazyCharts");

var _PercentageTotalVotesPerMonth = _interopRequireDefault(require("./ProductFeedbackDashboard/PercentageTotalVotesPerMonth"));

var _CompaniesDropdown = _interopRequireDefault(require("./ProductFeedbackDashboard/CompaniesDropdown"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _Message = require("../ui-components/Message");

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProductFeedbackDashboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductFeedbackDashboard, _Component);

  var _super = _createSuper(ProductFeedbackDashboard);

  function ProductFeedbackDashboard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ProductFeedbackDashboard);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "barChart", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "horizontalBarChart", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resizeTimeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.onResetDateRange();

        _this.setState({}, _this.removeHandler);
      }
    });

    var _getStartAndEndDate = (0, _utils.getStartAndEndDate)(),
        initialStartDate = _getStartAndEndDate.initialStartDate,
        initialEndDate = _getStartAndEndDate.initialEndDate,
        initalDateRangeId = _getStartAndEndDate.initalDateRangeId;

    var queryParams = new _QueryParameters.default();
    var defaultMetricItem = (0, _utils.createDefaultMetricItem)();

    _this.setState({
      selectedPresetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
      storedState: {
        presetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
        selectedDateRange: (0, _utils.getDefaultSelectedDate)()
      },
      selectedCompany: null,
      startDate: queryParams.has('date_from') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_from')) : initialStartDate,
      endDate: queryParams.has('date_till') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_till')) : initialEndDate,
      presetDateRangeList: [],
      isDateRangeOpen: false,
      isLoading: false,
      isCheckingStatusMapping: true,
      isKeyInsightLoading: false,
      shouldChartRedraw: false,
      showModal: false,
      storedStatusList: [],
      ideaStatusList: [],
      modalIdeaStatusList: [],
      isIdeaStatusMappingSetup: false,
      unmappedIdeaStatusCount: undefined,
      messageType: null,
      message: '',
      ideasCreated: defaultMetricItem,
      ideasDelivered: 0,
      votesDelivered: 0,
      votesAdded: defaultMetricItem,
      percentageTotalDeliveredVotes: 0,
      cumulativeTotalVotesOverTime: [],
      isLoadingCumulativeTotalVotesOverTime: false,
      isSalesforceIntegrationEnabled: true
    });

    _this.toggleDateRange = _this.toggleDateRange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDateRangeChanged = _this.onDateRangeChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetDateRange = _this.onResetDateRange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPresetDateRangeChanged = _this.onPresetDateRangeChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCustomDateRangeChanged = _this.onCustomDateRangeChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onIdeaStatusMappingChanged = _this.onIdeaStatusMappingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.showIdeaStatusMappingModal = _this.showIdeaStatusMappingModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveIdeaStatusMapping = _this.saveIdeaStatusMapping.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchData = _this.fetchData.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCompanySelect = _this.onCompanySelect.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ProductFeedbackDashboard, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var presetDateRanges, defaultDateRange, _this$state, storedState, selectedPresetDateRangeId, _dateRangeForDisplay, dateFrom, dateTill, selectedDateRange, selectedPresetId, updatedState, _yield$axios$get, data, isIdeaStatusMappingCount, defaultIdeaStatus;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _utils.trackDashboardUsage)('product-feedback-dashboard');
                this.redrawGraphsOnResize();
                _context.prev = 2;
                _context.next = 5;
                return this.fetchDateRangeFilter();

              case 5:
                presetDateRanges = _context.sent;
                defaultDateRange = (0, _utils.getDefaultDateRange)(presetDateRanges, this.state.selectedPresetDateRangeId);
                _this$state = this.state, storedState = _this$state.storedState, selectedPresetDateRangeId = _this$state.selectedPresetDateRangeId;
                _dateRangeForDisplay = (0, _utils.dateRangeForDisplay)(storedState, defaultDateRange, selectedPresetDateRangeId), dateFrom = _dateRangeForDisplay.dateFrom, dateTill = _dateRangeForDisplay.dateTill, selectedDateRange = _dateRangeForDisplay.selectedDateRange, selectedPresetId = _dateRangeForDisplay.selectedPresetId, updatedState = _dateRangeForDisplay.updatedState;
                _context.next = 11;
                return this.isSalesforceIntegrationEnabled();

              case 11:
                _context.next = 13;
                return _axios.default.get('/community/api/ideas/ideaStatuses');

              case 13:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;

                if (data.result.length) {
                  _context.next = 18;
                  break;
                }

                this.setState({
                  isCheckingStatusMapping: false,
                  isIdeaStatusMappingSetup: false,
                  showModal: false
                });
                return _context.abrupt("return");

              case 18:
                isIdeaStatusMappingCount = 0;
                defaultIdeaStatus = null;
                data.result.forEach(function (item) {
                  item.backgroundColor = "#".concat(item.backgroundColor);
                  item.textColor = "#".concat(item.textColor);

                  if (item.type === '') {
                    isIdeaStatusMappingCount = isIdeaStatusMappingCount + 1;
                  }

                  if (item.default) {
                    defaultIdeaStatus = item;
                  }
                });
                this.setState({
                  ideaStatusList: data.result,
                  storedStatusList: data.result,
                  defaultIdeaStatus: defaultIdeaStatus,
                  isLoading: false,
                  isCheckingStatusMapping: false,
                  presetDateRangeList: presetDateRanges,
                  selectedPresetDateRangeId: selectedPresetId,
                  selectedDate: selectedDateRange,
                  startDate: dateFrom,
                  endDate: dateTill,
                  storedState: updatedState
                });

                if (!(isIdeaStatusMappingCount === this.state.ideaStatusList.length)) {
                  _context.next = 25;
                  break;
                }

                this.setState({
                  showModal: true,
                  isIdeaStatusMappingSetup: false,
                  isCheckingStatusMapping: false,
                  unmappedIdeaStatusCount: isIdeaStatusMappingCount
                });
                return _context.abrupt("return");

              case 25:
                this.setState({
                  showModal: false,
                  isIdeaStatusMappingSetup: true,
                  isCheckingStatusMapping: false,
                  unmappedIdeaStatusCount: isIdeaStatusMappingCount
                });
                this.refetchData();
                _context.next = 32;
                break;

              case 29:
                _context.prev = 29;
                _context.t0 = _context["catch"](2);
                this.setState({
                  isLoading: false
                });

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 29]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "isSalesforceIntegrationEnabled",
    value: function () {
      var _isSalesforceIntegrationEnabled = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _yield$axios$post, data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _axios.default.post('/analyticsV2/isSalesforceIntegrationEnabled');

              case 2:
                _yield$axios$post = _context2.sent;
                data = _yield$axios$post.data;
                this.setState({
                  isSalesforceIntegrationEnabled: data.isSalesforceIntegrationEnabled
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function isSalesforceIntegrationEnabled() {
        return _isSalesforceIntegrationEnabled.apply(this, arguments);
      }

      return isSalesforceIntegrationEnabled;
    }()
  }, {
    key: "addHandler",
    value: function addHandler() {
      var isDateRangeOpen = this.state.isDateRangeOpen;

      if (isDateRangeOpen) {
        window.document.addEventListener('mousedown', this.handleClickOutside);
      }
    }
  }, {
    key: "removeHandler",
    value: function removeHandler() {
      window.document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "redrawGraphsOnResize",
    value: function redrawGraphsOnResize() {
      var _this2 = this;

      if (typeof window.ResizeObserver === 'undefined') {
        return;
      }

      var resizeObserver = new ResizeObserver(function () {
        clearTimeout(_this2.resizeTimeout);

        _this2.setState({
          shouldChartRedraw: true
        });

        _this2.resizeTimeout = window.setTimeout(function () {
          return _this2.setState({
            shouldChartRedraw: false
          });
        }, 2 * 10);
      });

      if (this.barChart != null) {
        resizeObserver.observe(this.barChart);
      }
    }
  }, {
    key: "fetchDateRangeFilter",
    value: function () {
      var _fetchDateRangeFilter = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var res;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _axios.default.get('/analyticsV2/fetchDateRangeFilter');

              case 2:
                res = _context3.sent;
                return _context3.abrupt("return", res.data.ranges);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function fetchDateRangeFilter() {
        return _fetchDateRangeFilter.apply(this, arguments);
      }

      return fetchDateRangeFilter;
    }()
  }, {
    key: "toggleDateRange",
    value: function toggleDateRange(value) {
      this.setState({
        isDateRangeOpen: value
      }, this.addHandler);
    }
  }, {
    key: "onPresetDateRangeChanged",
    value: function onPresetDateRangeChanged(selectedDate) {
      this.setState({
        selectedPresetDateRangeId: selectedDate.id,
        selectedDate: selectedDate
      });
    }
  }, {
    key: "onCustomDateRangeChanged",
    value: function onCustomDateRangeChanged(dates) {
      var customSelectedDate = {
        id: 'custom_range',
        label: 'Custom Range',
        startDate: dates[0],
        endDate: dates[1]
      };
      this.setState({
        selectedDate: customSelectedDate,
        selectedPresetDateRangeId: customSelectedDate.id
      });
    }
  }, {
    key: "onDateRangeChanged",
    value: function onDateRangeChanged() {
      var _this$state2 = this.state,
          selectedDate = _this$state2.selectedDate,
          selectedPresetDateRangeId = _this$state2.selectedPresetDateRangeId;

      var updatedState = _objectSpread({}, this.state.storedState);

      updatedState.presetDateRangeId = selectedPresetDateRangeId;
      updatedState.selectedDateRange = selectedDate;
      this.setState({
        isDateRangeOpen: false,
        startDate: new Date(selectedDate.startDate),
        endDate: new Date(selectedDate.endDate),
        storedState: updatedState
      });
      var queryString = new _QueryParameters.default();
      queryString.set('date_range', selectedPresetDateRangeId);

      if (selectedPresetDateRangeId !== 'custom_range') {
        queryString.unset('date_from').unset('date_till');
      } else {
        queryString.set('date_from', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.startDate)).set('date_till', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.endDate));
      }

      window.history.pushState(null, 'date range changed', queryString.getQueryString());
      (0, _utils.updateDateRangeInSessionStorage)(selectedDate);
      this.refetchData();
    }
  }, {
    key: "onResetDateRange",
    value: function onResetDateRange() {
      var _this$state$storedSta = this.state.storedState,
          presetDateRangeId = _this$state$storedSta.presetDateRangeId,
          selectedDateRange = _this$state$storedSta.selectedDateRange;
      this.setState({
        isDateRangeOpen: false,
        selectedPresetDateRangeId: presetDateRangeId,
        selectedDate: selectedDateRange
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showModal: false,
        showErrorMessage: false,
        ideaStatusList: this.state.storedStatusList
      });
    }
  }, {
    key: "showIdeaStatusMappingModal",
    value: function showIdeaStatusMappingModal() {
      // Get all unmapped idea statuses at the time of opening the modal
      var unmappedStatuses = this.state.ideaStatusList.filter(function (item) {
        return item.type === '';
      });
      this.setState({
        showModal: true,
        modalIdeaStatusList: unmappedStatuses // Set the filtered list when opening modal

      });
    }
  }, {
    key: "saveIdeaStatusMapping",
    value: function () {
      var _saveIdeaStatusMapping = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var ideaStatusList, hasUnmappedIdeaStatus;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ideaStatusList = this.state.ideaStatusList;
                hasUnmappedIdeaStatus = ideaStatusList.some(function (item) {
                  return item.type === '';
                });

                if (!hasUnmappedIdeaStatus) {
                  _context4.next = 5;
                  break;
                }

                this.setState({
                  showErrorMessage: true
                });
                return _context4.abrupt("return");

              case 5:
                _context4.prev = 5;
                _context4.next = 8;
                return _axios.default.post('/ideas/updateIdeaStatusType', {
                  mappedIdeaStatusList: this.state.ideaStatusList
                });

              case 8:
                this.setState({
                  showModal: false,
                  showErrorMessage: false,
                  isIdeaStatusMappingSetup: true,
                  unmappedIdeaStatusCount: 0,
                  storedStatusList: ideaStatusList,
                  messageType: 'success',
                  message: 'Ideation status mapping updated successfully!'
                });
                this.refetchData();
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](5);
                this.setState({
                  messageType: 'error',
                  message: "Something went wrong, ideation statuses can't be updated. Please try again."
                });

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 12]]);
      }));

      function saveIdeaStatusMapping() {
        return _saveIdeaStatusMapping.apply(this, arguments);
      }

      return saveIdeaStatusMapping;
    }()
  }, {
    key: "onIdeaStatusMappingChanged",
    value: function onIdeaStatusMappingChanged(item, status) {
      var updatedIdeaStatusList = this.state.ideaStatusList.map(function (i) {
        return i.id === item.id ? _objectSpread(_objectSpread({}, i), {}, {
          type: status
        }) : _objectSpread({}, i);
      });
      var updatedModalIdeaStatusList = this.state.modalIdeaStatusList.map(function (i) {
        return i.id === item.id ? _objectSpread(_objectSpread({}, i), {}, {
          type: status
        }) : _objectSpread({}, i);
      });
      this.setState({
        ideaStatusList: updatedIdeaStatusList,
        modalIdeaStatusList: updatedModalIdeaStatusList,
        showErrorMessage: false
      });
    }
  }, {
    key: "fetchKeyInsights",
    value: function () {
      var _fetchKeyInsights = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var res, _res$data, ideasCreated, votesAdded, ideasDelivered, votesDelivered, ideasCreatedPercentageDifference, votesAddedPercentageDifference;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.setState({
                  isKeyInsightLoading: true
                });
                _context5.prev = 1;
                _context5.next = 4;
                return this.fetchData('/analyticsV2/productFeedbackKeyInsights');

              case 4:
                res = _context5.sent;
                _res$data = res.data, ideasCreated = _res$data.ideasCreated, votesAdded = _res$data.votesAdded, ideasDelivered = _res$data.ideasDelivered, votesDelivered = _res$data.votesDelivered;
                ideasCreatedPercentageDifference = (0, _utils.previousPeriodDifference)(ideasCreated.count, ideasCreated.previousCount);
                votesAddedPercentageDifference = (0, _utils.previousPeriodDifference)(votesAdded.count, votesAdded.previousCount);
                this.setState({
                  ideasCreated: {
                    count: ideasCreated.count,
                    previousCount: ideasCreated.previousCount,
                    percentageDifference: ideasCreatedPercentageDifference
                  },
                  votesAdded: {
                    count: votesAdded.count,
                    previousCount: votesAdded.previousCount,
                    percentageDifference: votesAddedPercentageDifference
                  },
                  ideasDelivered: ideasDelivered.count,
                  votesDelivered: votesDelivered.count,
                  isKeyInsightLoading: false
                });
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](1);
                this.setState({
                  isKeyInsightLoading: false
                });

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 11]]);
      }));

      function fetchKeyInsights() {
        return _fetchKeyInsights.apply(this, arguments);
      }

      return fetchKeyInsights;
    }()
  }, {
    key: "fetchTotalDeliveredVotesOverTime",
    value: function () {
      var _fetchTotalDeliveredVotesOverTime = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var res, dataForInsight, percentTotalVotesDelivered, totalVotes;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.setState({
                  isLoadingCumulativeTotalVotesOverTime: true
                });
                _context6.prev = 1;
                _context6.next = 4;
                return this.fetchData('/analyticsV2/totalVotesOverTime', 'daily');

              case 4:
                res = _context6.sent;

                if (res.data.length !== 0) {
                  dataForInsight = res.data.slice(-1).pop();
                  percentTotalVotesDelivered = 0;
                  totalVotes = dataForInsight.open + dataForInsight.delivered;

                  if (totalVotes > 0) {
                    percentTotalVotesDelivered = dataForInsight.delivered / totalVotes * 100;
                  }

                  this.setState({
                    percentageTotalDeliveredVotes: Number(percentTotalVotesDelivered.toFixed(2))
                  });
                }

                this.setState({
                  cumulativeTotalVotesOverTime: res.data,
                  isLoadingCumulativeTotalVotesOverTime: false
                });
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](1);
                this.setState({
                  isLoadingCumulativeTotalVotesOverTime: false
                });

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 9]]);
      }));

      function fetchTotalDeliveredVotesOverTime() {
        return _fetchTotalDeliveredVotesOverTime.apply(this, arguments);
      }

      return fetchTotalDeliveredVotesOverTime;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url) {
        var group,
            sortingOptions,
            _this$state3,
            startDate,
            endDate,
            selectedCompany,
            filterOptions,
            _args7 = arguments;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                group = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : '';
                sortingOptions = _args7.length > 2 ? _args7[2] : undefined;
                _this$state3 = this.state, startDate = _this$state3.startDate, endDate = _this$state3.endDate, selectedCompany = _this$state3.selectedCompany;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false)
                };

                if (group !== '') {
                  Object.assign(filterOptions, {
                    group: group
                  });
                }

                if (sortingOptions) {
                  Object.assign(filterOptions, sortingOptions);
                }

                if (selectedCompany) {
                  Object.assign(filterOptions, {
                    company_id: selectedCompany.id,
                    page: 1,
                    pageSize: 100
                  });
                }

                _context7.next = 9;
                return _axios.default.post(url, {
                  filters: filterOptions
                });

              case 9:
                return _context7.abrupt("return", _context7.sent);

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: "refetchData",
    value: function refetchData() {
      this.fetchKeyInsights();
      this.fetchTotalDeliveredVotesOverTime();
    }
  }, {
    key: "getChartOptions",
    value: function getChartOptions() {
      return {
        title: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 24
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          intersect: false,
          mode: 'index',
          callbacks: {
            title: function title(item) {
              if (item.length > 0 && item[0].label) {
                var date = new Date(item[0].label.substr(0, 10));
                return _AnalyticsDateFormatter.default.getMonthAndDayForChartTooltip(date);
              }

              return '';
            }
          }
        },
        legend: {
          display: true,
          position: 'top',
          align: 'start',
          labels: {
            boxWidth: 12
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            offset: true,
            time: {
              minUnit: 'day'
            },
            gridLines: {
              display: false
            },
            ticks: {
              maxRotation: 0,
              callback: function callback(value) {
                return "      ".concat(value, "      ");
              }
            }
          }],
          yAxes: [{
            gridLines: {
              borderDash: [8, 4],
              color: _utils.BRAND_BORDER_GREY,
              drawBorder: false
            },
            stacked: true,
            ticks: {
              padding: 16,
              beginAtZero: true
            }
          }]
        },
        plugins: {
          datalabels: {
            display: false
          },
          crosshair: {
            line: {
              color: _utils.BRAND_GREY,
              width: 0.5 // crosshair line width

            },
            zoom: {
              enabled: false
            },
            sync: {
              enabled: false
            }
          }
        }
      };
    }
  }, {
    key: "getCumulativeVotesOverTime",
    value: function getCumulativeVotesOverTime(data) {
      return {
        labels: data.map(function (d) {
          return d.date;
        }),
        datasets: [{
          label: 'Delivered votes (cumulative)',
          // Name the series
          data: data.map(function (d) {
            return d.delivered;
          }),
          fill: true,
          lineTension: 0,
          pointRadius: 0,
          borderColor: _utils.BRAND_BLUE,
          // Add custom color border (Line)
          backgroundColor: _utils.BRAND_BLUE,
          // Add custom color background (Points and Fill)
          borderWidth: 1 // Specify bar border width

        }, {
          label: 'Open votes (cumulative)',
          // Name the series
          data: data.map(function (d) {
            return d.open;
          }),
          // Specify the data values array
          fill: true,
          lineTension: 0,
          pointRadius: 0,
          borderColor: _utils.BRAND_YELLOW,
          // Add custom color border (Line)
          backgroundColor: _utils.BRAND_YELLOW,
          // Add custom color background (Points and Fill)
          borderWidth: 1 // Specify bar border width

        }, {
          label: 'Closed votes (cumulative)',
          // Name the series
          data: data.map(function (d) {
            return d.closed;
          }),
          // Specify the data values array
          fill: true,
          lineTension: 0,
          pointRadius: 0,
          borderColor: _utils.BRAND_GREY,
          // Add custom color border (Line)
          backgroundColor: _utils.BRAND_GREY,
          // Add custom color background (Points and Fill)
          borderWidth: 1 // Specify bar border width

        }]
      };
    }
  }, {
    key: "onCompanySelect",
    value: function onCompanySelect(companyId, companyName) {
      if (companyId && companyName) {
        this.setState({
          selectedCompany: {
            id: companyId,
            name: companyName
          }
        });
      } else {
        this.setState({
          selectedCompany: null
        });
      }

      this.refetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state4 = this.state,
          isKeyInsightLoading = _this$state4.isKeyInsightLoading,
          shouldChartRedraw = _this$state4.shouldChartRedraw,
          presetDateRangeList = _this$state4.presetDateRangeList,
          isDateRangeOpen = _this$state4.isDateRangeOpen,
          selectedPresetDateRangeId = _this$state4.selectedPresetDateRangeId,
          startDate = _this$state4.startDate,
          endDate = _this$state4.endDate,
          isLoading = _this$state4.isLoading,
          isCheckingStatusMapping = _this$state4.isCheckingStatusMapping,
          defaultIdeaStatus = _this$state4.defaultIdeaStatus,
          selectedDate = _this$state4.selectedDate,
          showModal = _this$state4.showModal,
          isIdeaStatusMappingSetup = _this$state4.isIdeaStatusMappingSetup,
          unmappedIdeaStatusCount = _this$state4.unmappedIdeaStatusCount,
          ideaStatusList = _this$state4.ideaStatusList,
          showErrorMessage = _this$state4.showErrorMessage,
          messageType = _this$state4.messageType,
          message = _this$state4.message,
          ideasCreated = _this$state4.ideasCreated,
          votesAdded = _this$state4.votesAdded,
          ideasDelivered = _this$state4.ideasDelivered,
          votesDelivered = _this$state4.votesDelivered,
          percentageTotalDeliveredVotes = _this$state4.percentageTotalDeliveredVotes,
          cumulativeTotalVotesOverTime = _this$state4.cumulativeTotalVotesOverTime,
          isLoadingCumulativeTotalVotesOverTime = _this$state4.isLoadingCumulativeTotalVotesOverTime,
          selectedCompany = _this$state4.selectedCompany,
          isSalesforceIntegrationEnabled = _this$state4.isSalesforceIntegrationEnabled;
      var isVisibleFor = messageType === 'success' ? 5000 : false;
      var totalVotesGraph = (0, _preact.h)("div", {
        className: "graph-row-no-data-text"
      }, "There's no data yet");

      if (isIdeaStatusMappingSetup) {
        if (isLoadingCumulativeTotalVotesOverTime) {
          totalVotesGraph = (0, _preact.h)(_Loader.Loader, null);
        } else {
          totalVotesGraph = (0, _preact.h)(_LazyCharts.Line, {
            redraw: shouldChartRedraw,
            data: this.getCumulativeVotesOverTime(cumulativeTotalVotesOverTime),
            options: this.getChartOptions()
          });
        }
      }

      return (0, _preact.h)("div", {
        className: "product-feedback-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "product-feedback-dashboard"
      }, messageType ? (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        renderHTML: true,
        isVisibleFor: isVisibleFor
      }) : null, (0, _preact.h)(_header.default, {
        title: "Product Feedback Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), !isCheckingStatusMapping && (!isIdeaStatusMappingSetup || unmappedIdeaStatusCount && unmappedIdeaStatusCount !== 0 ? (0, _preact.h)(_SetupIdeaStatusMappingWarning.SetupIdeaStatusMappingWarning, {
        count: unmappedIdeaStatusCount,
        openModal: this.showIdeaStatusMappingModal
      }) : null), !isSalesforceIntegrationEnabled && (0, _preact.h)(_Message.Message, {
        text: (0, _preact.h)("div", null, "To enable the company filter, please configure the Salesforce integration and enable", ' ', (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/integrations/salesforce"),
          "data-element-name": "Import Saleseforce account data link",
          "data-track-type": "click"
        }, "'Import Salesforce account data to ", _constants.PLATFORM_BRAND_NAME, ".'"))
      }), (0, _preact.h)("div", {
        className: "filter-container"
      }, (0, _preact.h)("div", {
        ref: function ref(node) {
          _this3.wrapperRef = node;
        }
      }, (0, _preact.h)(_DashboardDateRangeFilter.default, {
        isLoading: isLoading,
        startDate: startDate,
        endDate: endDate,
        isDropdownOpen: isDateRangeOpen,
        items: presetDateRangeList,
        selectedDate: selectedDate,
        selectedPresetId: selectedPresetDateRangeId,
        toggleDropdown: this.toggleDateRange,
        onChange: this.onDateRangeChanged,
        onReset: this.onResetDateRange,
        onCustomDateChange: this.onCustomDateRangeChanged,
        onPresetDateChange: this.onPresetDateRangeChanged,
        showMonths: 2,
        "data-element-name": "date range filter",
        "data-track-type": "click"
      })), (0, _preact.h)(_CompaniesDropdown.default, {
        selectedCompany: selectedCompany,
        onCompanySelect: this.onCompanySelect,
        isSalesforceIntegrationEnabled: isSalesforceIntegrationEnabled
      })), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "% Total votes delivered",
        total: percentageTotalDeliveredVotes,
        isPercentage: true,
        titleTooltip: "The percentage of total cumulative votes delivered up to the end of the selected time period. Excludes closed votes.",
        isLoading: isLoadingCumulativeTotalVotesOverTime,
        hideComparisionWithPreviousPeriod: true,
        isKeyInsightAvailable: isIdeaStatusMappingSetup,
        keyInsightUnavailableMessage: "There's no data yet"
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Votes delivered",
        total: votesDelivered,
        titleTooltip: "The number of idea votes delivered in the selected time period.",
        isLoading: isKeyInsightLoading,
        hideComparisionWithPreviousPeriod: true,
        comparisionTooltip: "The percentage difference between the number of idea votes delivered in the current/previous time period.",
        isKeyInsightAvailable: isIdeaStatusMappingSetup,
        keyInsightUnavailableMessage: "There's no data yet"
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Votes added",
        total: votesAdded.count,
        titleTooltip: "The number of votes added to ideas in the selected time period.",
        percent: votesAdded.percentageDifference,
        showComparisionUnavailable: votesAdded.previousCount === 0,
        isLoading: isKeyInsightLoading,
        comparisionTooltip: "The percentage difference between the number of votes added to ideas in the current/previous time period.",
        isKeyInsightAvailable: isIdeaStatusMappingSetup,
        keyInsightUnavailableMessage: "There's no data yet"
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Ideas delivered",
        total: ideasDelivered,
        titleTooltip: "The number of ideas delivered in the selected time period.",
        isLoading: isKeyInsightLoading,
        comparisionTooltip: "The percentage difference between the number of ideas delivered in the current/previous time period.",
        hideComparisionWithPreviousPeriod: true,
        isKeyInsightAvailable: isIdeaStatusMappingSetup,
        keyInsightUnavailableMessage: "There's no data yet"
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Ideas created",
        total: ideasCreated.count,
        titleTooltip: "The number of ideas created in the selected time period.",
        isLoading: isKeyInsightLoading,
        percent: ideasCreated.percentageDifference,
        comparisionTooltip: "The percentage difference between the number of ideas created in the current/previous time period.",
        showComparisionUnavailable: ideasCreated.previousCount === 0,
        isKeyInsightAvailable: isIdeaStatusMappingSetup,
        keyInsightUnavailableMessage: "There's no data yet"
      })), (0, _preact.h)("div", {
        className: "graph-wrapper"
      }, (0, _preact.h)("div", {
        className: "graph-container",
        ref: function ref(element) {
          _this3.barChart = element;
        }
      }, (0, _preact.h)(_PercentageTotalVotesPerMonth.default, {
        shouldChartRedraw: shouldChartRedraw,
        isIdeaStatusMappingSetup: isIdeaStatusMappingSetup,
        startDate: startDate,
        endDate: endDate
      }), (0, _preact.h)("div", {
        className: "graph-row ".concat(!isIdeaStatusMappingSetup ? 'graph-row-no-data' : '')
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        customClass: "with-legend",
        title: "Total votes",
        tooltipMessage: "The cumulative total of open, delivered, and closed votes over time."
      }), totalVotesGraph))), (0, _preact.h)(_IdeaStatusMappingModal.IdeaStatusMappingModal, {
        isOpen: showModal,
        showError: showErrorMessage,
        list: this.state.modalIdeaStatusList,
        onClose: this.closeModal,
        onSave: this.saveIdeaStatusMapping,
        onChangeCallback: this.onIdeaStatusMappingChanged
      }), (0, _preact.h)("div", {
        className: "dashboard-table-wrapper ideation-trends-table-wrapper"
      }, (0, _preact.h)("div", {
        className: "ideation-trends-title"
      }, "Ideation trends", selectedCompany ? " for ".concat(selectedCompany.name) : '', (0, _preact.h)(_Tooltip.default, {
        position: "left",
        trigger: (0, _preact.h)(_assets.default, {
          icon: "question",
          width: 16,
          height: 16,
          customClass: "icon-info"
        }),
        customClasses: "graph-help-tooltip",
        tooltipMessage: (0, _preact.h)("div", null, (0, _preact.h)("p", null, "The ideation trends table shows the top 100 ideas raised in the community, sorted by the number of new votes, new replies, or new views that happened in the selected period.", ' '), (0, _preact.h)("p", null, "When a specific company is filtered the table shows the number of activities (votes, new replies, or new views) of company users out of total events."))
      })), (0, _preact.h)(_IdeationTrendsTable.default, {
        fetchData: this.fetchData,
        defaultIdeaStatus: defaultIdeaStatus,
        startDate: startDate,
        ideaStatusList: ideaStatusList,
        endDate: endDate,
        selectedCompany: selectedCompany
      })), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }]);
  return ProductFeedbackDashboard;
}(_preact.Component);

var _default = ProductFeedbackDashboard;
exports.default = _default;